import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const TYPES = ['default', 'email', 'primary'];

const Link = ({
  rel: relProp,
  target,
  className,
  style,
  type,
  href,
  children,
  onClick,
  id,
  email = false,
  'data-dd-action-name': dataDdActionName,
}) => {
  let rel = relProp || '';
  if (target === '_blank' && rel.indexOf('noopener noreferrer') < 0) {
    rel = `${rel} noopener noreferrer`;
  }

  return (
    <a
      href={href}
      className={clsx(
        'text-[14px] break-words cursor-pointer m-0 p-0',
        email && 'hover:underline',
        type === 'primary' ? 'text-legacy-primary' : 'text-legacy-caption',
        className,
      )}
      target={target}
      rel={rel}
      style={style}
      onClick={onClick}
      id={id}
      data-testid={id}
      data-dd-action-name={dataDdActionName}
    >
      {children}
    </a>
  );
};

Link.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  target: PropTypes.string,
  rel: PropTypes.string,
  type: PropTypes.oneOf(TYPES),
  children: PropTypes.node,
  id: PropTypes.string,
  email: PropTypes.bool,
  'data-dd-action-name': PropTypes.string,
};

export default Link;
